import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SolEstimatePricingMode } from '../../../models/enum';
import { SolEstimateTableRowBase } from '../../../models/sol-estimate-table/SolEstimateTableRowBase';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MultilingualCurrencyPipe } from "../../../pipes/multilingual-currency-pipe/multilingual-currency.pipe";

@Component({
  selector: 'app-sol-estimate-table-tax-not-included',
  imports: [
    TranslatePipe,
    CommonModule,
    ReactiveFormsModule
],
  templateUrl: './sol-estimate-table-tax-not-included.component.html',
  styleUrl: './sol-estimate-table-tax-not-included.component.scss'
})
export class SolEstimateTableTaxNotIncludedComponent {

  @Input() isMarkUpSelected: boolean = false;
  @Input() sellAsPricingMode: SolEstimatePricingMode = SolEstimatePricingMode.Line_Item;
  @Input() taxNotIncludedFormGroup: FormGroup<SolEstimateTableRowBase>;

}
